import { Component, OnInit } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';

import { ModalViewComponent } from '../modal-view.shared.component';
import { Observable } from 'rxjs';

@Component({
    selector: 'shared-modal-for-delivery-not-available',
    templateUrl: './modal-for-delivery-not-available.shared.component.html',
    styleUrls: ['./modal-for-delivery-not-available.shared.component.scss']
})
export class ModalForDeliveryNotAvailableComponent extends ModalViewComponent implements OnInit {
    public locationName$: Observable<string>;

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public routeService: Services.RouteService,
        public controllers: Controllers,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.size = 'xsm';

        this.locationName$ = this.controllers.locations.locationFriendlyName$(this.modalData.locationNo);
    }

    public handleViewOtherStoresClick($event: MouseEvent): void {
        this.close();
        this.controllers.routes.navigateToLocationsSearchView();
    }

    public handlePickUpClick($event: MouseEvent): void {
        this.close();
        this.controllers.collectionType.setCollectionType(OLO.Enums.COLLECTION_TYPE.PICKUP);
    }
}
